import { render, staticRenderFns } from "./Skills-Certificate.vue?vue&type=template&id=5b3606f9&scoped=true"
import script from "./Skills-Certificate.vue?vue&type=script&lang=js"
export * from "./Skills-Certificate.vue?vue&type=script&lang=js"
import style0 from "./Skills-Certificate.vue?vue&type=style&index=0&id=5b3606f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3606f9",
  null
  
)

export default component.exports